import { eLayoutType, RoutesService } from '@abp/ng.core';
import { APP_INITIALIZER } from '@angular/core';

export const WORK_SAFETY_AREAS_WORK_SAFETY_AREA_ROUTE_PROVIDER = [
  { provide: APP_INITIALIZER, useFactory: configureRoutes, deps: [RoutesService], multi: true },
];

function configureRoutes(routes: RoutesService) {
  return () => {
    routes.add([
      {
        path: '/work-safety-areas',
        iconClass: 'fas fa-file-alt',
        name: '::Menu:WorkSafetyAreas',
        layout: eLayoutType.application,
        order: 12,
        requiredPolicy: 'Enova.WorkSafetyAreas',
      },
    ]);
  };
}
